import {makeStyles} from '@material-ui/core/styles'
import CollapseForCard from '../../2compounds/CollapseForCard'
import {DeleteIconButton, Text} from '../../1elements'
import SelectFeatureSetModal from './SelectFeatureSetModal'
import {useEffect, useMemo, useState} from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import {
    checkSelected, createFeaturesCheckList,
    groupFeatureByCategory,
    selectedCounter,
    uncheckItem
} from '../../../services/util/miscellaneousService'
import SubCollapseForCard from '../../2compounds/SubCollapseForCard'

const SelectedFeatureSet = ({selectedFeatureSets, setSelectedFeatureSets, showError}) => {
    const classes = useStyles()
    const [open, setOpen] = useState(false)
    const groupedList = useMemo(
        () => groupFeatureByCategory(selectedFeatureSets),
        [selectedFeatureSets]
    )
    const assignedFeatureCount = Object.values(groupedList)
        .reduce((total, features) => total + selectedCounter(features), 0)

    const header = (
        <>
            Assigned Feature Set
            <span className={'requiredAsterisk'}>*</span>
        </>
    )

    const errorHandler = () => {
        const selected = checkSelected(selectedFeatureSets)
        if(showError&&!selected){
            return 'Assign at least one feature set'
        }
    }

    const openHandler = () => {
        setOpen(true)
    }

    const deleteFeature = (id) => {
        const updatedList = uncheckItem(selectedFeatureSets, id, 'feature_id')
        setSelectedFeatureSets(updatedList)
    }

    useEffect(()=>{
        if(selectedFeatureSets.length === 0){
            createFeaturesCheckList()
                .then((data)=>{
                    setSelectedFeatureSets(data)
                })
        }

    }, [selectedFeatureSets, setSelectedFeatureSets])

    return (
        <div className={classes.root}>
            <CollapseForCard header={header} dataCount={assignedFeatureCount} onClick={openHandler}>
                <div>
                    <List>
                    {Object.keys(groupedList).map((groupName, index)=>(
                        <ListItem key={index} className={classes.listItem} divider>
                            <SubCollapseForCard header={groupName} dataCount={selectedCounter(groupedList[groupName])}>
                                {groupedList[groupName].map((selectedFeatureList, index)=>(
                                    groupedList[groupName][index].selected &&
                                    <div key={selectedFeatureList.feature_id || index} className={classes.nameDeleteDiv}>
                                        <Text type='detailInfoHead'>{selectedFeatureList.name}</Text>
                                        <DeleteIconButton onClick={()=> deleteFeature(selectedFeatureList.feature_id)}
                                        className={classes.deleteIcon}/>
                                    </div>
                                ))}
                            </SubCollapseForCard>
                        </ListItem>
                    ))}
                    </List>
                </div>
            </CollapseForCard>
            <div className={classes.errorMessageDiv}>
                <Text type='textFieldError'>{errorHandler()}</Text>
            </div>
            <SelectFeatureSetModal open={open} setOpen={setOpen}
                                   featureSets={selectedFeatureSets}
                                   setFeatureSets={setSelectedFeatureSets} />
        </div>


    )
}

export default SelectedFeatureSet

const useStyles = makeStyles({
    root: {
    },
    errorMessageDiv: {
        margin: '0 14px'
    },
    listItem: {
        padding: '0 16px'
    },
    nameDeleteDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
    },
    deleteIcon: {
        padding: 0
    }
})
